<template>
  <div class="flex items-center h-full">
    <div v-if="measureCodes.length > 0" class="flex flex-wrap gap-1">
      <span
        v-for="code in displayCodes"
        :key="code"
        class="px-1.5 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-700"
        :title="code"
      >
        {{ abbreviate(code) }}
      </span>
      <span
        v-if="extraCount > 0"
        class="px-1.5 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600"
        :title="hiddenCodes.join(', ')"
      >
        +{{ extraCount }}
      </span>
    </div>
    <span v-else class="text-xs text-gray-400">-</span>
  </div>
</template>

<script>
export default {
  name: 'Quality_MeasureCell',
  props: ['params'],
  data() {
    return {
      maxDisplay: 3
    };
  },
  computed: {
    measureCodes() {
      return this.params.data?.measure_codes || [];
    },
    displayCodes() {
      return this.measureCodes.slice(0, this.maxDisplay);
    },
    hiddenCodes() {
      return this.measureCodes.slice(this.maxDisplay);
    },
    extraCount() {
      return Math.max(0, this.measureCodes.length - this.maxDisplay);
    }
  },
  methods: {
    abbreviate(code) {
      // Common abbreviations for measure codes
      const abbrevMap = {
        'Colorectal Cancer Screening': 'COL',
        'Breast Cancer Screening': 'BCS',
        'Diabetes: Hemoglobin A1c': 'A1C',
        'Diabetes: Eye Exam': 'EYE',
        'Controlling High Blood Pressure': 'BP',
        'Statin Therapy': 'STAT',
        'Depression Screening': 'DEP',
        'Fall Risk Assessment': 'FALL',
        'Medication Reconciliation': 'MED',
        'Care Plan': 'CARE',
        'Tobacco Screening': 'TOB',
        'BMI Screening': 'BMI'
      };

      // Check for exact match
      if (abbrevMap[code]) return abbrevMap[code];

      // Check for partial match
      for (const [full, abbrev] of Object.entries(abbrevMap)) {
        if (code.toLowerCase().includes(full.toLowerCase().split(':')[0].split(' ')[0])) {
          return abbrev;
        }
      }

      // Default: take first 3-4 chars of each word
      const words = code.split(/[\s-:]+/).filter(w => w.length > 2);
      if (words.length === 1) {
        return words[0].substring(0, 4).toUpperCase();
      }
      return words.map(w => w[0]).join('').substring(0, 4).toUpperCase();
    }
  }
};
</script>
